var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTutorialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 24C41 14.6112 33.3888 7 24 7C14.6112 7 7 14.6112 7 24C7 33.3888 14.6112 41 24 41C33.3888 41 41 33.3888 41 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 24C40 15.1634 32.8366 8 24 8C15.1634 8 8 15.1634 8 24C8 32.8366 15.1634 40 24 40C32.8366 40 40 32.8366 40 24Z",
    stroke: "url(#paint0_linear_5_3)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 35.6875C30.4548 35.6875 35.6875 30.4548 35.6875 24C35.6875 17.5452 30.4548 12.3125 24 12.3125C17.5452 12.3125 12.3125 17.5452 12.3125 24C12.3125 30.4548 17.5452 35.6875 24 35.6875Z",
    fill: "url(#paint1_linear_5_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 35.1875C30.1787 35.1875 35.1875 30.1787 35.1875 24C35.1875 17.8213 30.1787 12.8125 24 12.8125C17.8213 12.8125 12.8125 17.8213 12.8125 24C12.8125 30.1787 17.8213 35.1875 24 35.1875Z",
    stroke: "url(#paint2_linear_5_3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.5137 23.5048C29.0007 23.7769 29.0007 24.4574 28.5137 24.7296L21.9395 28.4042C21.4525 28.6764 20.8437 28.3362 20.8438 27.7918V20.4426C20.8438 19.8982 21.4525 19.558 21.9395 19.8302L28.5137 23.5048Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5_3",
    x: 0.625,
    y: 0.625,
    width: 46.75,
    height: 46.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.172549 0 0 0 0 0.172549 0 0 0 0 0.172549 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_3",
    x1: 24,
    y1: 7,
    x2: 24,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6941C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A461D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_3",
    x1: 16.5,
    y1: 15.5,
    x2: 31.5,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6941C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_3",
    x1: 24,
    y1: 12.3125,
    x2: 24,
    y2: 35.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6941C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A461D8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialIcon);
export default __webpack_public_path__ + "static/media/tutorial-icon.2a28cc8745f3cf99ac0c9b51791a8800.svg";
export { ForwardRef as ReactComponent };